export default {
  ru: "RU",
  en: "EN",
  CoursesTitle: "Курстар | " + process.env.VUE_APP_INSTALL_NAME + "",
  Module_AI: {
    title: "Жасанды интеллект",
    desc: "Медициналық кескіндерді ЖИ-сервистермен талдау",
  },
  Module_edu: {
    title: "Білім",
    desc: "Көру жаттықтырғыштары, курстар және дәрігерлерге арналған пайдалы материалдар",
  },
  Module_community: {
    title: "Қоғамдастық",
    desc: "Клиникалық жағдайлар бойынша дәрігерлер арасында білім алмасу",
  },
  Profile: "Профиль",
  Subscription: "Жазылым",
  "Go to site": "Сайтқа өту",
  "Access after pay": "Сабақ әлі ашылмаған",
  Exit: "Шығу",
  MY: "ЖТ",
  Home: "Басты бет",
  "Mobile banner text : demo":
    "Аккаунт құрыңыз және ЖИ-сервистер мен жаттықтырғыштарға толық қол жеткізіңіз",
  Platform: "ДӘРІГЕРЛЕРГЕ АРНАЛҒАН ПЛАТФОРМА",
  "Platform info":
    "ЖИ көмекшілері, көру жаттықтырғыштары, курстар және дәрігерлерге арналған пайдалы материалдар",
  "Download app": "Қосымшаны жүктеу",
  "Home title":
    "Дәрігерлерге арналған платформа | " +
    process.env.VUE_APP_INSTALL_NAME +
    "",
  AI: "ЖИ",
  edu: "Білім",
  community: "Қоғамдастық",
  "Your courses": "Сіздің курстарыңыз",
  "Recomended courses": "Ұсынылған курстар",
  Courses: "Курстар",
  Calculator: "Калькулятор",
  Plug: "Қосу",
  "Go to": "Өту",
  Case: "Тапсырма",
  Cases: "Тапсырмалар",
  "Case success": "Орындалды",
  "Case unsuccess": "Орындалмады",
  Modality: "Модалдылық",
  "Page title tail": " | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Cant find service?": "Қажетті сервисті таба алмадыңыз ба?",
  "Text us": "Бізге жазыңыз",
  "I need AI for...": "Маған келесіге арналған ЖИ-сервис керек ...",
  "Thx for reply": "Ұсынысыңыз үшін рахмет!",
  Send: "Жіберу",
  Sent: "Жіберілді",
  "Cannot loading reply -- adblock":
    "Жіберу мүмкін болмады. VPN немесе жарнама бұғаттағыш сияқты кеңейтулерді өшіріңіз",
  Favorites: "Таңдаулылар",
  "Cases about 1": "Өз ісіңізді қосыңыз",
  "Cases about 2":
    "Қызықты жағдайларды талқылаңыз, сұрақтар қойыңыз, тәжірибе алмасыңыз! Іс қосыңыз, барлық зерттеулер",
  "Cases about 3": "анонимделеді",
  "Add case": "Іс қосу",
  All: "Барлығы",
  "I upload": "Жүктелген",
  drafts: "Қараламалар",
  draft: "Қаралама",
  "Case v2": "Іс",
  "Open study": "Зерттеуді ашу",
  Comments: "Пікірлер",
  "Comment placeholder": "Пікір жазу...",
  "Favorites about 1": "Қазір мұнда ештеңе жоқ, белгішені басыңыз",
  "Favorites about 2": "қызықты іс таңдалғандарға қосу үшін",
  "Comment screen info 1": "Скриншотты тіркеу үшін,",
  "Comment screen info 2": "зерттеуді қарау құралында ашыңыз",
  Download: "Жүктеу",
  "Record Date": "Дәріс жазбасы",
  "Request a course": "Курсқа жазылу",
  "Request a course doned": "Сіз курсқа өтініш қалдырдыңыз",
  "Forgot password?": "Құпиясөзді ұмыттыңыз ба?",
  "Reset password": "Құпиясөзді қалпына келтіру",
  "Reset password v2": "Құпиясөзді қалпына келтіру",
  "Reset password about":
    "Тіркелу кезінде көрсетілген электронды поштаны енгізіңіз. Біз құпиясөзді қалпына келтіру нұсқаулығын жібереміз",
  "Reset password about after":
    "Құпиясөзді қалпына келтіру сілтемесі поштаға жіберілді",
  "Back to prev page": "Алдыңғы бетке оралу",
  Email: "Электрондық пошта",
  "Not valid email": "Электрондық пошта пішімі дұрыс емес",
  EmailAlreadyRegistered:
    "Бұл электрондық пошта мекенжайы қазірдің өзінде тіркелген",
  NotActivatedAccount:
    "Пайдаланушы тіркелген, бірақ аккаунты әлі белсендірілмеген.",
  "Not found email": "Электрондық пошта тіркелмеген",
  "Back to login": "Кіру бетіне оралу",
  "Email not come?": "Хат келмеді ме?",
  "Write to support": "Қолдау қызметіне жазыңыз",
  "Create new password": "Жаңа құпиясөзді жасаңыз",
  "Password confirm": "Құпиясөзді растау",
  "Min 8": "Кемінде 8 таңба",
  "Two inputs don't match!": "Құпиясөздер сәйкес келмейді",
  "Update password": "Құпиясөзді жаңарту",
  "Password updated": "Құпиясөз жаңартылды",
  "Invalid password token": "Сілтеме жарамсыз, қайтадан көріңіз",
  "Unknown user": "Белгісіз пайдаланушы",
  "Attach image": "Суретті тіркеу",
  Remove: "Жою",
  Complain: "Шағымдану",
  "Complain sent": "Сіздің шағымыңыз сәтті жіберілді",
  owner: "Авторы",
  assistant: "Куратор",
  "Answers 1": "жауап",
  "Answers 2": "жауап",
  "Answers 3": "жауап",
  "Add answer": "Жауап беру",
  "Collapse answers": "Жауаптарды жасыру",
  "Image only": "<Сурет>",
  "Cannot upload from mobile":
    "DICOM форматындағы зерттеулерді тек компьютерден жүктей аласыз",
  "Password rule": "Кемінде 8 таңба, 1 латын әрпі және 1 сан енгізіңіз",
  ReferenceCursors: "C - 3D курсор",
  "bad browser for mpr":
    "MPR жұмыс істемеуі мүмкін. Соңғы нұсқадағы Google Chrome браузерін пайдалануды ұсынамыз",
  "Service in process": "Қызмет уақытша қол жетімді емес",
  "Service in process about":
    "Бірақ сіз демонстрациялық зерттеулер негізінде қызметтің мүмкіндіктерін көре аласыз. Жеке зерттеулерді өңдеу мүмкін болған кезде біз сізге хабарлаймыз.",
  "Edit case": "Кейсті өңдеу",
  Title: "Атауы",
  "Access count": "Қолжетімді",
  "Access count about":
    "«Барлығына қолжетімді» опциясын таңдасаңыз, жарияланым бәріне көрінеді. Сілтеме арқылы қолжетімді болса, оны тек «Бөлісу» батырмасынан кейін көруге болады.",
  "To All": "Барлығына",
  "To Link": "Сілтеме арқылы",
  Publish: "Жариялау",
  "Publish about":
    "Анонимді жарияланған жағдайда, сіздің атыңыз бен компанияңыз басқа пайдаланушыларға көрінбейді.",
  How: "Қалай",
  "As Anon": "Анонимді түрде",
  "Case accept": "Мен пациенттің жеке деректерін орналастырмаймын.",
  "User Policy": "Құпиялық саясаты",
  "Remove case": "Кейсті жою",
  "Save draft": "Жоба ретінде сақтау",
  "Remove case success": "Кейс сәтті жойылды",
  "Remove case error": "Кейсті жою мүмкін болмады. Кейінірек қайталап көріңіз",
  "Update case error":
    "Кейсті жаңарту мүмкін болмады. Кейінірек қайталап көріңіз",
  Edit: "Өңдеу",
  "Cases v2": "Кейстер",
  sec: " сек",
  "Confirm accept": "Келісімді растаңыз",
  "Remove case?": "Серияны жою керек пе?",
  "Upload AI": "DICOM форматында зерттеу жүктеңіз",
  "Upload edu": "DICOM, JPEG немесе PNG форматындағы кейсті жүктеңіз",
  "Upload community": "DICOM, JPEG немесе PNG форматындағы кейсті жүктеңіз",
  "As anon": "Анонимді түрде",
  status: {
    free: "Тегін",
    subscription: "Жазылым арқылы",
    draft: "Жоба",
  },
  noAcceptResult: "Сіз келіспеген жайтты сипаттаңыз",
  Meta: {
    tail: "%s | " + process.env.VUE_APP_INSTALL_NAME + "",
    tail2: " | " + process.env.VUE_APP_INSTALL_NAME + "",
    default: {
      title: "Дәрігерлерге арналған платформа",
      desc: process.env.VUE_APP_INSTALL_DESC,
    },
    "community-cases": {
      title: "Медициналық қауымдастық",
      desc: "Дәрігерлерге арналған кәсіби онлайн қауымдастық – қызықты клиникалық жағдайларды талқылау, сұрақтар мен тәжірибе алмасу!",
    },
    home: {
      title: "Дәрігерлерге арналған платформа",
      desc: "Онлайн медициналық платформа: ЖИ көмекшілері, визуалды тәжірибе тренажерлері, курстар және дәрігерлерге арналған пайдалы материалдар",
    },
    "ai-services": {
      title: "ЖИ Қызметтері",
      desc: "Ауруларды диагностикалауға арналған жасанды интеллект қызметтері",
    },
    "edu-services": {
      title: "Дәрігерлерге арналған білім беру платформасы",
      desc: "Диагност дәрігерлерге арналған оқу курстары мен білім базасының тізімі.",
    },
  },
  "Video is unavailable": "Бейне қолжетімсіз",
  Licence:
    '© 2025 "Платформа ' +
    process.env.VUE_APP_INSTALL_NAME +
    '" ЖШС, СТН 7714420229, БСН 5177746328106, барлық құқықтар қорғалған. 121205, Мәскеу қ., Сколково Инновациялық орталығының аумағы, Нобель к-сі 7 үй, 2 қабат, 37-бөлме, жұмыс орны 2',
  "Policy v2": "Жеке деректерді өңдеу және қорғау саясаты",
  "Site company": "Компания сайты",
  homepage: {
    connect: "Байланысу ",
    cost: " / ай",
    goToAI: "Зерттеулерді өңдеу",
    notAuthSub__off: {
      title: "ЖИ көмекшісінің барлық мүмкіндіктерін ашыңыз",
      desc: "Өлшеулерді автоматтандыру және қорытынды жасау үшін ЖИ көмекшісіне қол жеткізіңіз",
    },
    notAuthSub__on: {
      title: "Медициналық бейнелерді талдауға арналған ЖИ қызметтері",
      desc: "Өлшеулерді автоматтандырады және зерттеу протоколын жасайды. 3 зерттеуді тегін өңдеңіз, содан кейін — <PRICE> үшін көбірек",
    },
    baseSub: {
      title: "Зерттеулерді талдау кезінде рутиналық жұмыстан арылыңыз",
      desc: "ЖИ көмекші өлшеулерді автоматтандырып, 1 шерту арқылы қорытынды жасайды",
    },
    notBaseSub: {
      title: "Суретті 1 шерту арқылы жүктеңіз",
      desc: "Өлшеулерді автоматтандыру және қорытынды жасау үшін ЖИ көмекшісін пайдаланыңыз",
    },
  },
  "Start type": "Енгізуді бастаңыз...",
  buy: "Сатып алу",
  more_details: "Толығырақ оқыңыз",
};
